/**
 * "مسح كل البيانات" (L6293, L6345). In the original one confirm() wiped everything; here it is
 * admin-only, requires the phrase and the password, and the server writes a backup first.
 */
import { useState } from 'react';
import { Modal } from '@/components/ui';
import { useApiMutation } from '@/hooks/useApi';
import { useNotify } from '@/app/providers/NotifyProvider';
import { api } from '@/services/api';

const PHRASE = 'مسح كل البيانات';

export function ResetDataModal({ onClose }: { onClose: () => void }) {
  const notify = useNotify();
  const [confirm, setConfirm] = useState('');
  const [password, setPassword] = useState('');
  const reset = useApiMutation((b: { confirm: string; password: string }) => api.post<{ backupFile: string }>('/migration/reset', b));
  const submit = async () => {
    const r = await reset.mutateAsync({ confirm, password });
    notify.success('تم مسح البيانات. نسخة احتياطية: ' + r.data.backupFile);
    onClose();
  };
  return (
    <Modal title="مسح جميع البيانات؟" onClose={onClose}>
      <div className="space-y-3">
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800 leading-6">
          سيتم حذف كل بيانات العمل (العملاء، الطلبات، المنتجات، المالية، المخزون…). تُحفظ نسخة احتياطية تلقائياً على الخادم قبل المسح. المستخدمون والصلاحيات لا تُحذف.
        </div>
        <div>
          <label className="lbl" htmlFor="rs-phrase">
            اكتب «{PHRASE}» للتأكيد
          </label>
          <input id="rs-phrase" className="inp" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <div>
          <label className="lbl" htmlFor="rs-pw">كلمة المرور</label>
          <input id="rs-pw" className="inp" type="password" dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button type="button" className="btn-p w-full py-3" style={{ background: '#c62828' }} disabled={confirm !== PHRASE || !password || reset.isPending} onClick={submit}>
          مسح كل البيانات
        </button>
      </div>
    </Modal>
  );
}
